import { render, staticRenderFns } from "./list.vue?vue&type=template&id=363a90ce&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=363a90ce&prod&scoped=true&lang=css&"
import style1 from "./list.css?vue&type=style&index=1&id=363a90ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a90ce",
  null
  
)

export default component.exports